import { useAuth } from '../auth/AuthProvider';
import { Bell, Globe, Shield } from 'lucide-react';

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div>
      <h2 className="text-lg font-semibold text-white mb-4">Settings</h2>

      <div className="space-y-6 max-w-2xl">
        {/* Organisation Info */}
        <div className="card">
          <h3 className="text-sm font-semibold text-gray-300 mb-4 flex items-center gap-2">
            <Globe size={14} /> Organisation
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <label className="block text-xs text-gray-500 mb-1">Organisation Name</label>
              <div className="py-2 text-gray-200">{user?.org_name}</div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Organisation Type</label>
              <div className="py-2 text-gray-200 capitalize">{user?.org_type}</div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Organisation ID</label>
              <div className="py-2 font-mono text-xs text-gray-400">{user?.org_id}</div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">Region</label>
              <div className="py-2 text-gray-200">NZ</div>
            </div>
          </div>
          <p className="text-[11px] text-gray-600 mt-3">
            Contact Kinetica support to update organisation details.
          </p>
        </div>

        {/* Notification Preferences */}
        <div className="card">
          <h3 className="text-sm font-semibold text-gray-300 mb-4 flex items-center gap-2">
            <Bell size={14} /> Notifications
          </h3>
          <div className="space-y-3">
            {[
              { label: 'Critical Faults', desc: 'E-stop, hardware faults (always on)', locked: true },
            ].map((pref) => (
              <div key={pref.label} className="flex items-center justify-between px-3 py-2.5 rounded-lg bg-surface-2/50">
                <div>
                  <div className="text-sm text-gray-200">{pref.label}</div>
                  <div className="text-[11px] text-gray-500">{pref.desc}</div>
                </div>
                <div className="text-xs text-emerald-400 font-medium">Always On</div>
              </div>
            ))}
            {[
              { label: 'Device Status Changes', desc: 'Online/offline/idle transitions' },
              { label: 'Billing Alerts', desc: 'Invoice due, grace period, suspension' },
              { label: 'OTA Deployments', desc: 'Firmware and model update status' },
              { label: 'Training Complete', desc: 'Model training job notifications' },
            ].map((pref) => (
              <div key={pref.label} className="flex items-center justify-between px-3 py-2.5 rounded-lg bg-surface-2/50">
                <div>
                  <div className="text-sm text-gray-200">{pref.label}</div>
                  <div className="text-[11px] text-gray-500">{pref.desc}</div>
                </div>
                <div className="text-xs text-gray-600 font-medium">Coming soon</div>
              </div>
            ))}
          </div>
        </div>

        {/* Security */}
        <div className="card">
          <h3 className="text-sm font-semibold text-gray-300 mb-4 flex items-center gap-2">
            <Shield size={14} /> Security
          </h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-gray-200">Change Password</div>
                <div className="text-[11px] text-gray-500">Update your Cognito password</div>
              </div>
              <span className="text-xs text-gray-600 font-medium">Coming soon</span>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-gray-200">Active Sessions</div>
                <div className="text-[11px] text-gray-500">Manage signed-in devices</div>
              </div>
              <span className="text-xs text-gray-600 font-medium">Coming soon</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
